module.exports = __webpack_public_path__ + "images/emoji/vhs.e0c6c9277e5dbcef1836.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/vhs.png
// module id = eQI2
// module chunks = 1